/**
 * 移动端底部 TabBar：时间相册 / 那些话 / 我。
 *
 * 管理设置是 owner 专属的账号入口，不属于双人空间的主内容导航，
 * 因此不在底部 TabBar 中占用一个一级位置。
 */

import React from 'react';
import { AlbumIcon, LetterIcon, UserIcon } from './icons';
import { useUnreadBadge } from './unreadBadge';

export type TabKey = 'album' | 'letters' | 'account';

export interface MobileTabBarProps {
  /** 当前激活 tab；null 表示停留在非 tab 页（如 /home） */
  active: TabKey | null;
  onChange: (next: TabKey) => void;
}

interface TabSpec {
  key: TabKey;
  label: string;
  Icon: React.FC<{ size?: number }>;
  testId: string;
}

const TAB_DEFS: TabSpec[] = [
  { key: 'album', label: '相册', Icon: AlbumIcon, testId: 'tab-album' },
  { key: 'letters', label: '那些话', Icon: LetterIcon, testId: 'tab-letters' },
  { key: 'account', label: '我', Icon: UserIcon, testId: 'tab-account' },
];

export const MobileTabBar: React.FC<MobileTabBarProps> = ({ active, onChange }) => {
  const { count: unreadCount } = useUnreadBadge();
  const visibleTabs = TAB_DEFS;

  return (
    <nav
      className={`fp-mobile-tabbar fp-mobile-tabbar--count-${visibleTabs.length}`}
      aria-label="底部导航"
    >
      {visibleTabs.map((tab) => {
        const isActive = active === tab.key;
        const { Icon } = tab;
        return (
          <button
            key={tab.key}
            type="button"
            className={
              'fp-mobile-tabbar__item' + (isActive ? ' fp-mobile-tabbar__item--active' : '')
            }
            data-testid={tab.testId}
            onClick={() => onChange(tab.key)}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={22} />
            {tab.key === 'account' && unreadCount > 0 ? (
              <span className="fp-mobile-tabbar__unread-dot" data-testid="tab-account-unread-dot" aria-label={`${unreadCount} 条未读通知`} />
            ) : null}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
